export type Color =
  '#8661C5'
  | '#D59DFF'
  | '#008575'
  | '#30E5D0'
  | '#107C10'
  | '#9BF00B'
  | '#EEEEEE'
  | '#50E6FF'
  | '#0078D4'
  | '#9BF00B'
  | '#107C10'
  | '#253d04'
  | '#2f0e39'
  | '#5c17c6'
  | '#094f59'
  | '#0080ff';

export const Purple: Color = '#8661C5';
export const DarkPurple: Color = '#2f0e39';
export const MidDarkPurple: Color = '#5c17c6';
export const LightPurple: Color = '#D59DFF';
export const Cyan: Color = '#008575';
export const DarkCyan: Color = '#094f59';
export const LightCyan: Color = '#30E5D0';
export const Green: Color = '#107C10';
export const DarkGreen: Color = '#253d04';
export const LightGreen: Color = '#9BF00B';
export const LightGray: Color = '#EEEEEE';
export const LightBlue: Color = '#0080ff';
